import type { AppLanguage } from '@/shared/i18n/types';

import enFile from './en.json';
import jaFile from './ja.json';
import type { WpaI18nSchema } from './types';


// 仅导出命名空间内的键（去掉顶层命名空间包装）
const ja = (jaFile as { wpa: WpaI18nSchema }).wpa;
const en = (enFile as { wpa: WpaI18nSchema }).wpa;

export const wpaNamespaceResources: Record<AppLanguage, WpaI18nSchema> = {
  ja,
  en,
};

